export default {
    MAPS_APIKEY: 'AIzaSyCywtRgiMi53e349zazmEfCoSyNbMAfisA',
    STATIC_URL: '//maps.googleapis.com/maps/api/staticmap?sensor=false',
};
